export const COMPANY = {
  name: 'Bay City Remodeling & Bathrooms LLC',
  shortName: 'Bay City Remodeling',
  phone: '813-362-0114',
  phoneFull: '+18133620114',
  address: 'Brandon, FL 33511',
  rating: 5.0,
  reviewCount: 58,
  logo: 'https://www.baycityremodeling.com/uplift-data/images/companyLogo.png',
  mapEmbed: 'https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d189633.99840593894!2d-82.36994996769364!3d27.97376404939151!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1760036512358!5m2!1sen!2sus',
  googleMapsUrl: 'https://maps.app.goo.gl/2PMoq86XZvKXG2Xk6',
  reviewUrl: 'https://tinyurl.com/27bxanwu',
  yearsExp: 18,
};

export const SERVICES = [
  {
    slug: 'home-remodeling',
    title: 'Home Remodeling',
    short: 'High-performance home remodeling designed for daily living and long-term value.',
    description: 'A significant home remodeling project dramatically enhances your property\'s appeal and functionality. We manage every facet, from structural changes to aesthetic updates, ensuring a cohesive, thoughtfully designed outcome for your living space.',
    image: 'https://www.baycityremodeling.com/uplift-data/images/services/home-remodeling.jpg',
    heroImage: 'https://www.baycityremodeling.com/uplift-data/images/banners/remodeling-experts-brandon.jpg',
  },
  {
    slug: 'bathroom-remodeling',
    title: 'Bathroom Remodeling',
    short: 'Spa-level bathrooms with modern finishes and efficient layouts.',
    description: 'Transform your outdated washroom into a luxurious sanctuary with our specialized bathroom remodeling services. We consider fixtures, tiling, and layout, crafting comfort with sophisticated design.',
    image: 'https://www.baycityremodeling.com/uplift-data/images/services/bahtroom-remodeling.jpg',
    heroImage: 'https://www.baycityremodeling.com/uplift-data/images/services/bahtroom-remodeling.jpg',
  },
  {
    slug: 'kitchen-remodeling',
    title: 'Kitchen Remodeling',
    short: 'High-performance kitchens designed for both daily living and entertaining.',
    description: 'The kitchen is the heart of a home. Our kitchen remodeling services make yours beautiful and highly efficient. We assist with cabinet selections, countertop materials, and appliance integration for a culinary space that serves your family.',
    image: 'https://www.baycityremodeling.com/uplift-data/images/services/kitchen-remodeling.jpg',
    heroImage: 'https://www.baycityremodeling.com/uplift-data/images/services/kitchen-remodeling.jpg',
  },
  {
    slug: 'full-home-renovations',
    title: 'Full Home Renovations',
    short: 'Complete interior transformations with cohesive design and execution.',
    description: 'When your family needs more room or a complete transformation, a well-planned full home renovation provides upgraded space without moving. We construct seamless additions and renovations, blending with your existing architecture.',
    image: 'https://www.baycityremodeling.com/uplift-data/images/services/additions.jpg',
    heroImage: 'https://www.baycityremodeling.com/uplift-data/images/banners/premier-remodeling-in-brandon.jpg',
  },
  {
    slug: 'interior-upgrades',
    title: 'Interior Upgrades & Custom Work',
    short: 'Flooring, cabinetry, trim, and layout improvements.',
    description: 'Flawless drywall installation, custom cabinetry, premium flooring, and trim work are fundamental to any refined interior. Our team ensures smooth, durable surfaces and beautiful finishes throughout your home.',
    image: 'https://www.baycityremodeling.com/uplift-data/images/services/drywall.jpg',
    heroImage: 'https://www.baycityremodeling.com/uplift-data/images/services/drywall.jpg',
  },
  {
    slug: 'outdoor-living',
    title: 'Outdoor Living',
    short: 'Patios, decks, pergolas, and outdoor kitchens crafted for Florida living.',
    description: 'Extend your living area beyond interior walls with an inviting outdoor space. We design and build patios, decks, pergolas, and outdoor kitchens, creating areas for relaxation, entertaining, and enjoying the Florida climate.',
    image: 'https://www.baycityremodeling.com/uplift-data/images/services/outdoor-living.jpg',
    heroImage: 'https://www.baycityremodeling.com/uplift-data/images/services/outdoor-living.jpg',
  },
];

export const SERVICE_AREAS = [
  { name: 'Brandon, FL', slug: 'brandon-fl' },
  { name: 'Riverview, FL', slug: 'riverview-fl' },
  { name: 'Seffner, FL', slug: 'seffner-fl' },
  { name: 'Valrico, FL', slug: 'valrico-fl' },
  { name: 'Tampa, FL', slug: 'tampa-fl' },
  { name: 'Plant City, FL', slug: 'plant-city-fl' },
  { name: 'Mango, FL', slug: 'mango-fl' },
  { name: 'Hyde Park, FL', slug: 'hyde-park-fl' },
  { name: 'Bloomingdale, FL', slug: 'bloomingdale-fl' },
  { name: 'Apollo Beach, FL', slug: 'apollo-beach-fl' },
  { name: 'Ruskin, FL', slug: 'ruskin-fl' },
  { name: 'Progress Village, FL', slug: 'progress-village-fl' },
  { name: 'Dover, FL', slug: 'dover-fl' },
  { name: 'Palm River-Clair Mel, FL', slug: 'palm-river-clair-mel-fl' },
  { name: 'East Lake-Orient Park, FL', slug: 'east-lake-orient-park-fl' },
  { name: 'Fish Hawk, FL', slug: 'fish-hawk-fl' },
  { name: 'Gibsonton, FL', slug: 'gibsonton-fl' },
  { name: 'Thonotosassa, FL', slug: 'thonotosassa-fl' },
  { name: 'Boyette, FL', slug: 'boyette-fl' },
  { name: 'Temple Terrace, FL', slug: 'temple-terrace-fl' },
  { name: 'Balm, FL', slug: 'balm-fl' },
  { name: 'University, FL', slug: 'university-fl' },
  { name: 'Egypt Lake, FL', slug: 'egypt-lake-fl' },
];

export const TESTIMONIALS = [
  {
    id: 1,
    text: 'Bay City Remodeling gave our bathroom a stunning makeover. Quick, professional, and the results are amazing. Highly recommend!',
    author: 'Maria T.',
    location: 'Brandon, FL',
    rating: 5,
    service: 'Bathroom Remodeling',
  },
  {
    id: 2,
    text: 'Professional, responsive, and the final result exceeded expectations. They handled our full kitchen renovation flawlessly from start to finish.',
    author: 'James R.',
    location: 'Riverview, FL',
    rating: 5,
    service: 'Kitchen Remodeling',
  },
  {
    id: 3,
    text: 'The team transformed our kitchen into something we actually enjoy spending time in. Every detail was handled with care and precision.',
    author: 'Sandra L.',
    location: 'Valrico, FL',
    rating: 5,
    service: 'Kitchen Remodeling',
  },
  {
    id: 4,
    text: 'From initial consultation to final walkthrough, Bay City Remodeling was transparent, on-time, and delivered exceptional craftsmanship throughout our home renovation.',
    author: 'David M.',
    location: 'Tampa, FL',
    rating: 5,
    service: 'Home Remodeling',
  },
  {
    id: 5,
    text: 'Our master bathroom was outdated for years. Bay City turned it into a spa-like retreat. The tile work and layout changes are incredible. Couldn\'t be happier.',
    author: 'Christine H.',
    location: 'Brandon, FL',
    rating: 5,
    service: 'Bathroom Remodeling',
  },
  {
    id: 6,
    text: 'Honest pricing, clear communication, and quality you can see. They delivered exactly what was promised — and then some.',
    author: 'Robert K.',
    location: 'Seffner, FL',
    rating: 5,
    service: 'Full Home Renovation',
  },
];

export const PROCESS_STEPS = [
  {
    step: '01',
    title: 'Consultation & Vision Planning',
    description: 'Understand your goals, space, and budget. We listen closely to what you want and establish a clear direction before anything begins.',
  },
  {
    step: '02',
    title: 'Design & Scope Development',
    description: 'Create a detailed plan, layout, and material direction. You receive a full scope with transparent pricing before work starts.',
  },
  {
    step: '03',
    title: 'Build & Project Execution',
    description: 'Skilled craftsmanship with consistent communication throughout. You stay informed at every stage of the build.',
  },
  {
    step: '04',
    title: 'Final Walkthrough & Completion',
    description: 'Ensure everything meets expectations before we call it done. We walk through every detail together and address anything before closing the project.',
  },
];

export const WHY_CHOOSE_US = [
  { icon: 'ri-medal-line', title: 'Detail-Driven Craftsmanship', text: 'Every project is treated with the same care and precision — no shortcuts, no compromises.' },
  { icon: 'ri-list-check-3', title: 'Clean, Structured Project Management', text: 'Organized timelines, clear milestones, and a team that actually shows up and delivers.' },
  { icon: 'ri-chat-check-line', title: 'Transparent Communication', text: 'You\'re never left guessing. Updates, changes, and decisions happen with you, not around you.' },
  { icon: 'ri-home-smile-line', title: 'Built for Function and Resale Value', text: 'Designs that improve how you live today and increase your home\'s market value for tomorrow.' },
  { icon: 'ri-map-pin-line', title: 'Local Experience & Accountability', text: 'We\'re rooted in the Brandon area. Our reputation depends on doing excellent work in our own community.' },
];

export const GALLERY_IMAGES = [
  { src: 'https://www.baycityremodeling.com/uplift-data/images/projects/project-1.jpg', alt: 'Remodeling project 1' },
  { src: 'https://www.baycityremodeling.com/uplift-data/images/projects/project-2.jpg', alt: 'Remodeling project 2' },
  { src: 'https://www.baycityremodeling.com/uplift-data/images/projects/project-3.jpg', alt: 'Remodeling project 3' },
  { src: 'https://www.baycityremodeling.com/uplift-data/images/projects/project-4.jpg', alt: 'Remodeling project 4' },
  { src: 'https://www.baycityremodeling.com/uplift-data/images/projects/project-5.jpg', alt: 'Remodeling project 5' },
];

export const HOME_FAQS = [
  {
    q: 'Who provides home remodeling near me?',
    a: 'Bay City Remodeling & Bathrooms LLC provides kitchen, bathroom, and full-home remodeling services in the Brandon, FL area, focusing on quality craftsmanship and modern design tailored to each home.',
  },
  {
    q: 'How much does a remodeling project cost?',
    a: 'Costs vary based on scope, materials, and layout changes. Kitchen and bathroom remodels typically range widely depending on finishes and customization, but a consultation provides a clear, accurate estimate with no surprises.',
  },
  {
    q: 'How long does a remodel take?',
    a: 'Most remodeling projects take anywhere from a few weeks to a few months depending on size, complexity, and material timelines. We provide a detailed project schedule before work begins.',
  },
  {
    q: 'Can I customize every detail of my bathroom remodel?',
    a: 'Absolutely. We believe your bathroom should be a personal retreat, reflecting your individual taste. From tile patterns to vanity styles and lighting fixtures, every element is open for your input.',
  },
  {
    q: 'How long does a kitchen remodel usually take?',
    a: 'A kitchen remodel duration varies based on scope. Minor cosmetic updates may take a few weeks, while major renovations with layout changes and custom cabinetry can range from 6 to 12 weeks or more. We provide a detailed timeline upfront.',
  },
  {
    q: 'Are you licensed and insured?',
    a: 'Yes. Bay City Remodeling & Bathrooms LLC is fully licensed, bonded, and carries workers\' compensation and general liability insurance on every project.',
  },
];
